module.exports = __webpack_public_path__ + "static/media/banner_careerTree.04cc0226.png";